// extracted by mini-css-extract-plugin
module.exports = {"root":"w_b","isInvert":"w_3","heading":"w_4","description":"w_5","dividerAnimation":"w_p"};